import React from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import { ReactComponent as LogoText } from 'images/lw-text-logo.svg';

const AppConfigError = () => {
	return (
		<Stack sx={{ gap: 100 }}>
			<LogoText />
			<Typography variant="title-lg">Config Error</Typography>
			<Typography variant="body-md">
				No configuration file was found.
			</Typography>
		</Stack>
	);
};

export default AppConfigError;
